export const AT_SUBSCRIPTIONS_INIT = 'SUBSCRIPTIONS_SUBSCRIPTIONS_INIT';
export const AT_SUBSCRIPTIONS_UPDATE = 'SUBSCRIPTIONS_SUBSCRIPTIONS_UPDATE';
export const AT_SUBSCRIPTION_ACTION_SET = 'SUBSCRIPTIONS_SUBSCRIPTION_ACTION_SET';
export const AT_SUBSCRIPTION_DELETE = 'SUBSCRIPTIONS_SUBSCRIPTION_DELETE';
